import { component } from 'flightjs';
import WithAjax from 'tradera/legacy/static/app/data/with-ajax';

function BankIdRecoveryUi() {
    this.attributes({
        bankIdAppLnk: '[data-bankId-restore-app-link]',
        resetEmailLnk: '[data-bankId-reset-email-lnk]',
        divInProgress: '[data-bankId-restore-inProgress]',
        divCompleted: '[data-bankId-restore-complete]',
        hdnRoute: '[data-bankId-restore-changePwdRoute]',
        setNewPwdbtn: '[data-bankId-restore-set-new-pwd]',
        divError: '[data-bankId-restore-error]',
        divErrorContainer: '[data-bankId-restore-error-cnt]',
        qrImage: '[data-bankId-qr-img]'
    });

    this.pollProgress = function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        setTimeout(function () {
            self._get({
                url: '/login/verifybankIdProgress',
                error: function () {
                    self.showError('Avbruten');
                },
                success: function (data) {
                    if (data.errorMessage) {
                        self.showError(/*data.errorMessage*/);
                    } else if (data.isCompleted) {
                        self.showComplete(data.token);
                    } else {
                        $(self.attr.qrImage).attr(
                            'src',
                            `data:image/png;base64, ${data.qrData}`
                        );
                        self.pollProgress();
                    }
                }
            });
        }, 3000);
    };

    this.showComplete = function (token) {
        $(this.attr.divInProgress).addClass('hidden');
        $(this.attr.divCompleted).removeClass('hidden');
        $(this.attr.resetEmailLnk).attr(
            'href',
            $(this.attr.resetEmailLnk).attr('href') + '?key=' + token
        );
    };

    this.showError = function () {
        $(this.attr.divInProgress).addClass('hidden');
        $(this.attr.divError).removeClass('hidden');
    };

    this.startPolling = function () {
        const error = $('.security-box__message security-error');
        if (error.length === 0) {
            this.pollProgress();
        }
    };

    this.after('initialize', function () {
        this.startPolling();
    });
}

export default component(BankIdRecoveryUi, WithAjax);
